module.exports = __webpack_public_path__ + "static/home-company-vision-img-5f34772078f570a52c4331367f8c17a7.png";